export default (theme) => ({
  groupQuestionContainer: {
    marginBottom: theme.spacing(2),
  },
  groupQuestionName: {
    marginBottom: theme.spacing(2),
    fontSize: 16,
    fontFamily: 'Roboto-Bold'
  },
  groupDescription: {
    marginBottom: theme.spacing(2),
  },
  groupQuestionTitle: {
    marginBottom: theme.spacing(2),
    fontSize: 20,
    fontFamily: 'Roboto-Bold',
    '&.newDesign': {
      textAlign: 'center',
    }
  },
  questionsContent: {
    '&.align-center': {
      justifyContent: 'center'
    }
  }
})